import moment from "moment-timezone";

import { TotalTicketsResult } from "src/core/dashboard/api/widget-data.api";

import {
  DisplayRangeType,
  groupByDisplayRange
} from "../../utils";
import { TotalTicketsGraphValue } from "../TotalTicketsWidget";

/**
 * Helper to group total tickets by date
 *
 * @param totalTickets A list of flat total tickets
 * @param displayRange DisplayRangeType
 * @returns
 *
 * ### Example.
 *
 * **In:**
 * ```
 * const totalTickets = [
 *  {
      "date": "2022-01-31T00:00:00.000Z",
      "count": 1
    },
    {
      "date": "2022-01-31T00:00:00.000Z",
      "count": 1
    },
    {
      "date": "Thu Feb 03 2022 00:00:00",
      "count": 1
    }
 * ]
 * const displayRange = "month"
 * ```
 * **Out:**
 * ```
 *[
    {
      "date": "2022-01-01T00:00:00.000Z",
      "count": 2
    },
    {
      "date": "2022-02-01T00:00:00.000Z",
      "count": 1
    }
  ]
 * ```
 */
export const groupTotalTickets = (totalTickets: TotalTicketsResult, displayRange: DisplayRangeType): TotalTicketsGraphValue[] => {
  const result: TotalTicketsGraphValue[] = [];
  // Group the data based on displayRange
  const groupedTotalTicketsData = groupByDisplayRange(totalTickets, displayRange);

  // Loop grouped data to form the result, ensuring to include date and all relevant counts accumulated
  for (const groupDate in groupedTotalTicketsData) {
    const accumulativeTotals = { count: 0 };

    groupedTotalTicketsData[ groupDate ].forEach(row => {
      accumulativeTotals.count += row.count;
    });

    const dataItem: TotalTicketsGraphValue = {
      date: moment.utc(groupDate).toDate(),
      ...accumulativeTotals
    };

    // Force header to include date day if displayRange not by month
    if (displayRange !== "month") {
      dataItem.toolTipHeader = moment.utc(groupDate).format("Do MMMM YYYY");
    }

    result.push(dataItem);
  }

  return result;
};
